// All action times

const contacts = {
  REQUEST_CONTACT_LIST: 'REQUEST_CONTACT_LIST',
  RECEIVE_CONTACT_LIST: 'RECEIVE_CONTACT_LIST',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  REQUEST_LIST_DETAILS: 'REQUEST_LIST_DETAILS',
  RECEIVE_LIST_DETAILS: 'RECEIVE_LIST_DETAILS'
}

export default contacts



// WEBPACK FOOTER //
// ./src/routes/Contacts/actions/actiontypes.js